import React from 'react';
import cls from 'classnames';
import fallback from '../../../assets/fallback-image.png';

export enum BackgroundColor {
  KIWI = 'kiwi',
  CLOUD = 'cloud',
  GRAPE = 'grape',
  LEMON = 'lemon',
  POMELO = 'pomelo',
}
export interface ISupporter {
  name: string;
  imageURL: string;
  color?: string;
  fit?: boolean;
}
export interface ISupportersContainer {
  title: string;
  titleSize: 'sm' | 'md';
  titleCenter?: boolean;
  description: string;
  supporters: ISupporter[];
  background: BackgroundColor;
}

export const SupportersContainer: React.FC<ISupportersContainer> = (props) => {
  const { title, titleSize, titleCenter, description, supporters, background } = props;
  return (
    <section
      className={cls({
        'bg-cloud-800 text-cloud-400': background === BackgroundColor.CLOUD,
        'bg-kiwi-400 border-t border-cloud-900 text-cloud-900': background !== BackgroundColor.CLOUD,
      })}
    >
      <div className="flex flex-col gap-3 w-full py-9 app-container mx-auto px-2">
        <h4
          className={cls('mb-2', {
            'text-lg': titleSize === 'sm',
            'text-display-md': titleSize === 'md',
            'text-center': titleCenter,
          })}
        >
          {title}
        </h4>
        {description && <p className="text-lg max-w-43 mb-9">{description}</p>}
        <div className="flex flex-wrap gap-x-1.5 gap-y-4 justify-center">
          {supporters &&
            supporters.map((supporter, index) => (
              <figure key={index} className="flex flex-col items-center justify-between">
                <div
                  className={cls('rounded-xl w-22 lg:w-20 h-12 lg:h-10.25 overflow-hidden mb-2', {
                    'bg-pureblack border border-cloud-900': supporter.color === 'black',
                    'bg-cloud-800 border border-cloud-700': supporter.color === 'cloud',
                    'bg-white border border-cloud-900': supporter.color !== 'black' && supporter.color !== 'cloud',
                  })}
                >
                  <img
                    onError={({ currentTarget }): void => {
                      currentTarget.onerror = null;
                      currentTarget.src = fallback;
                    }}
                    className={cls('w-full h-full', {
                      'object-cover': !supporter.fit,
                      'object-fit': supporter.fit,
                      'text-cloud-50': supporter.color === 'cloud',
                    })}
                    src={supporter.imageURL}
                  />
                </div>
                <figcaption className="text-lg">{supporter.name}</figcaption>
              </figure>
            ))}
        </div>
      </div>
    </section>
  );
};
